import { useEffect, useMemo } from "react";
import {
  useCreateDeviceGroup,
  useDeleteDeviceGroup,
  useDeleteDeviceGroupsList,
  useFetchDeviceGroups,
  useFetchDeviceGroupsList,
  useFetchDevices,
  useUpdateDeviceGroup,
  useUpdateDeviceGroupsList
} from "../../../apiHooks";
import { fleetManagementSections } from "../../../consts";

export const useFetchDeviceData = (activePage) => {
  const {
    fetchCallback: fetchDevices,
    data: devices,
    loading: devicesLoading,
    refresh: devicesRefresh
  } = useFetchDevices();

  const {
    fetchCallback: fetchDeviceGroups,
    data: deviceGroups,
    loading: deviceGroupsLoading,
    refresh: deviceGroupsRefresh
  } = useFetchDeviceGroups();

  const { mutationCallback: createDeviceGroup, loading: createDeviceGroupLoading } =
    useCreateDeviceGroup();

  const { mutationCallback: updateDeviceGroup, loading: updateDeviceGroupLoading } =
    useUpdateDeviceGroup();

  const { mutationCallback: deleteDeviceGroup, loading: deleteDeviceGroupLoading } =
    useDeleteDeviceGroup();

  const { mutationCallback: updateDeviceGroupsList, loading: updateDeviceGroupsListLoading } =
    useUpdateDeviceGroupsList();

  const { mutationCallback: deleteDeviceGroupsList, loading: deleteDeviceGroupsListLoading } =
    useDeleteDeviceGroupsList();

  const {
    fetchCallback: fetchDeviceGroupsList,
    loading: deviceGroupsListLoading,
    refresh: deviceGroupsListRefresh
  } = useFetchDeviceGroupsList();

  const mercuryDevices = useMemo(
    () => devices?.filter((device) => device.isMercuryDevice) || [],
    [devices]
  );

  useEffect(() => {
    if (devicesRefresh) {
      fetchDevices(true);
      fetchDeviceGroupsList(true);
      fetchDeviceGroups(true);
    }
  }, [devicesRefresh]);

  useEffect(() => {
    if (deviceGroupsRefresh) {
      fetchDeviceGroups(true);
    }
  }, [deviceGroupsRefresh]);

  useEffect(() => {
    if (deviceGroupsListRefresh) {
      fetchDeviceGroupsList(true);
    }
  }, [deviceGroupsListRefresh]);

  useEffect(() => {
    if (activePage === fleetManagementSections.DEVICES) {
      fetchDevices();
      fetchDeviceGroupsList();
      fetchDeviceGroups();
    }
  }, [activePage]);

  return {
    devices,
    mercuryDevices,
    deviceGroups,
    devicesLoading,
    deviceGroupsLoading: deviceGroupsLoading || deviceGroupsListLoading,
    deviceGroupChangesLoading:
      createDeviceGroupLoading || updateDeviceGroupLoading || deleteDeviceGroupLoading,
    deviceGroupListChangesLoading: updateDeviceGroupsListLoading || deleteDeviceGroupsListLoading,

    createDeviceGroup,
    updateDeviceGroup,
    deleteDeviceGroup,
    updateDeviceGroupsList,
    deleteDeviceGroupsList
  };
};
